import { Typography } from '@mui/material';
import typography from '../../styles/typography.module.css';
import { useTranslation } from 'react-i18next';
export const IEMDescription = ({ model, description } : {model: string, description: string}) => {
    const { t } = useTranslation();
    const modelInfo = t(`${model}.caption`);
    const info =
        modelInfo.localeCompare(`${model}.caption`) === 0 || modelInfo === undefined
            ? description
            : modelInfo;
    return <Typography className={typography.modelDescription}>{info}</Typography>;
};
